import React from 'react'
import { Button, Slide, Snackbar } from '@material-ui/core';
import TableComponent, { TableOp } from '../../../../components/table/TableOps'
import Http from '../../../../Http';
export default class AsingnarLP extends TableComponent {
  
  async componentDidMount() {
    const { id_cliente, cliente_id_condicion_pago } = this.props;
    this.tableConfig(
      { dataUrl: `lista-precio/cliente-asignar/${id_cliente}?cliente_id_condicion_pago=${cliente_id_condicion_pago}` },
      TableOp.Table(false, [
        { label: 'Asignada', id: 'ASIGNADA', type: 'checkbox',  callback: this.onListaPrecioChange },
        { label: 'Lista de Precio', id: 'lp_nombre' },
        { label: 'Tipo', id: 'tipo' },
      ], []))
    await this.table();
  }

  onListaPrecioChange = (event, index, field) => {
    const  { tableData } = this.state;
    let value = event.target.value;
    tableData.rows[index][field] = value;
    this.setState({ tableData });
  }

  onSaveLp = async () => {
    const { tableData }= this.state;
    const { id_cliente, cliente_id_condicion_pago }= this.props;
    const Resp = await Http.post('cliente-precio/saverel', { listas_precios: tableData.rows, id_cliente, cliente_id_condicion_pago });
    if (!Resp.error) {
      this.setState({
        sbOpen: true,
        sbMsg: 'Guardado'
      }, () => {
        this.props.onSave()
      })
    } else {
      this.setState({
        sbOpen: true,
        sbMsg: 'Ocurrio un error al guardar'
      }, () => {
        this.props.onSave()
      })
    }
  }

  render() {
    const { sbMsg, sbOpen } = this.state;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} >
        <div style={{ width: '100%' }} >
          <this.TableRender  pagination={false}/>
        </div>
        <Button
          style={{ marginLeft: 10, maxWidth: 250 }}
          variant="contained"
          color={'primary'}
          onClick={this.onSaveLp}
        >
        Guardar Lista Precios
      </Button>
      <Snackbar
          resumeHideDuration={2000}
          autoHideDuration={2000}
          open={sbOpen === undefined ? false : sbOpen}
          onClose={() => {
            this.setState({ sbOpen: false });
          }}
          TransitionComponent={Slide}
          message={<span>{sbMsg}</span>}
        />
      </div>
    )
  }
}
